'use client'

import { useState, forwardRef, type FormEvent } from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid'
import { cn } from '../../helpers'

export interface JosefSearchInputProps {
  placeholder?: string
  onSearch: (value: string) => void
  defaultValue?: string
  className?: string
  inputClassName?: string
  buttonClassName?: string
}

export const JosefSearchInput = forwardRef<
  HTMLFormElement,
  JosefSearchInputProps
>(
  (
    {
      placeholder = 'Search...',
      onSearch,
      defaultValue = '',
      className,
      inputClassName,
      buttonClassName,
    },
    ref
  ) => {
    const [inputValue, setInputValue] = useState(defaultValue)

    const handleSubmit = (e: FormEvent) => {
      e.preventDefault()
      if (inputValue.trim()) {
        onSearch(inputValue)
      }
    }

    return (
      <form
        ref={ref}
        onSubmit={handleSubmit}
        className={cn('relative', className)}
      >
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder={placeholder}
          className={cn(
            'w-60 h-10 pl-3 pr-12 bg-white dark:bg-black rounded-lg text-black dark:text-white placeholder:text-black/50 dark:placeholder:text-white/50 focus:outline-none',
            inputClassName
          )}
        />
        <button
          type="submit"
          className={cn(
            'absolute right-1.5 top-1/2 -translate-y-1/2 h-7 w-7 flex items-center justify-center rounded-md bg-black dark:bg-white text-white dark:text-black hover:bg-neutral-800 dark:hover:bg-neutral-200 transition-colors',
            buttonClassName
          )}
        >
          <MagnifyingGlassIcon className="w-4 h-4" />
        </button>
      </form>
    )
  }
)

JosefSearchInput.displayName = 'JosefSearchInput'
